import { render } from "./PreviewLimitedFeaturePopover.vue?vue&type=template&id=0f5129df&scoped=true"
import script from "./PreviewLimitedFeaturePopover.vue?vue&type=script&lang=js"
export * from "./PreviewLimitedFeaturePopover.vue?vue&type=script&lang=js"

import "./PreviewLimitedFeaturePopover.vue?vue&type=style&index=0&id=0f5129df&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5129df"]])

export default __exports__